import { useEffect, useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import s from './Signature.modules.scss'
import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { Delete } from '@mui/icons-material'

const Signature = ({ signatureRef, signatureError, initialImage, onSignatureChange }) => {
  const containerRef = useRef(null)

  const [isEmpty, setIsEmpty] = useState(true)
  const [canvasWidth, setCanvasWidth] = useState(0)

  useEffect(() => {
    const resizeCanvas = () => {
      if (containerRef.current) {
        setCanvasWidth(containerRef.current.offsetWidth)
      }
    }

    resizeCanvas() // initial size
    window.addEventListener('resize', resizeCanvas)

    return () => window.removeEventListener('resize', resizeCanvas)
  }, [])

  useEffect(() => {
    if (initialImage && signatureRef.current) {
      const canvas = signatureRef.current.getCanvas()

      const imageUrl = URL.createObjectURL(initialImage)

      signatureRef.current.fromDataURL(imageUrl, {
        width: canvas.width,
        height: canvas.height
      })
    }
  }, [initialImage])

  const clearSignature = () => {
    signatureRef.current.clear()
    setIsEmpty(true)
    onSignatureChange?.(false)
  }

  return (
    <div className={s.signatureContainer} ref={containerRef}>
      <h2>Semneaza mai jos</h2>

      <SignatureCanvas
        ref={signatureRef}
        penColor="black"
        canvasProps={{
          width: canvasWidth,
          height: canvasWidth * 0.6,
          className: 'sigCanvas',
          style: {
            width: '100%',
            height: `${canvasWidth * 0.6}px`,
            border: '1px solid #ccc',
            borderRadius: '8px'
          }
        }}
        onEnd={() => {
          setIsEmpty(signatureRef.current.isEmpty())
          onSignatureChange?.(true)
        }}
      />

      <div className={s.signatureActions} style={{ marginTop: '10px' }}>
        <div className={s.signatureError}>{signatureError}</div>
        <IconButton
          startIcon={<Delete />}
          size="large"
          variant="outlined"
          label="Sterge semnatura"
          onClick={clearSignature}
        />
      </div>
    </div>
  )
}

export default Signature
